import React, {Component} from 'react'
import Base from '../BaseComponent'
import Content from '../Content'
import Link from '../Link'

class CallToAction extends Component {

  render () {


		let _this = this;

    const ctaLink = this.props.location.callToActionLink
    const ctaTitle = this.props.location.callToActionTitle

    return (

      <div className="CallToAction">
          <Link url={ctaLink} modifiers={['button']} title={ctaTitle} blank={true} />
      </div>


    )
  }
}

export default CallToAction



// WEBPACK FOOTER //
// ./src/js/components/CallToAction/CallToAction.jsx